import React from 'react';

import { observer } from 'mobx-react';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { SectionBanner, Paragraph, Box } from 'components';
import Files from 'apps/files';
import { useNoAuthRedirect, useClientStore } from 'apps/hooks';
import { BANNER_ACTIONS } from 'constants/analytics';
import { analytics } from 'core/analytics';
import DocumentHead from 'legacyComponents/documentHead';

const FilesPage = observer(() => {
  const clientStore = useClientStore();
  const { isMobile, activeSpace } = clientStore;

  useNoAuthRedirect();

  const title =
    activeSpace?.spaceType === 'INITIATIVE'
      ? `${activeSpace?.content?.title}'s Files`
      : 'My Files';

  return (
    <MainWrapper marginBottom='4em'>
      <DocumentHead title={title} />
      {!isMobile && (
        <SectionBanner
          bannerId='files-design-reviews'
          imageSrc='/assets/banners/005.svg'
          title='Make design reviews a breeze.'
          buttonText='Share a File'
          linkName='https://wikifactory.com/share-file'
          paddingTop='large'
          paddingBottom='xlarge'
          eventCallback={() => analytics.sendEvent(BANNER_ACTIONS.FILES)}
        >
          <Box>
            <Paragraph>
              Securely <strong>view, share,</strong> and{' '}
              <strong>collaborate</strong> on your CAD files with your company,
              clients, and stakeholders.
            </Paragraph>
            <Paragraph>
              Simply <strong>upload your CAD models</strong> to Wikifactory,{' '}
              <strong>invite users</strong> and{' '}
              <strong>grant permissions</strong> to get everyone on the same
              page.
            </Paragraph>
          </Box>
        </SectionBanner>
      )}
      <Files />
    </MainWrapper>
  );
});

export default FilesPage;
